// One "stop the background offline sync" signal (OFFLINE_SYNC_SPEED_PLAN_2026-10-03.md, step A).
//
// Fired when the session ends (logout, forced logout, session-expired dialog) and when a different
// user / company is about to wipe the offline data. The prefetch queue and the sync run listen: they
// stop starting new requests, the "Preparing offline data" strip hides, and nothing from the old
// session is written after this point. Plain module (no Angular) so any service can call it.

type CancelListener = (reason: string) => void;

const listeners = new Set<CancelListener>();

/** Stops the offline sync for the session that just ended. Safe to call any number of times. */
export function cancelOfflineSync(reason: string): void {
  listeners.forEach((fn) => {
    try { fn(reason); } catch { /* one listener failing must not block the others */ }
  });
}

/** Subscribe to cancel signals; returns the unsubscribe function. */
export function onOfflineSyncCancel(fn: CancelListener): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}
